import { Container, Stack } from "@mui/material"
import { useState, useEffect, useMemo } from "react";
import { Button } from "src/@/components/ui/button"
import { Input } from "src/@/components/ui/input"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "src/@/components/ui/select"
import { Label } from "src/@/components/ui/label"

import { Bar, BarChart, CartesianGrid, XAxis, YAxis, PieChart, Pie, Cell, ResponsiveContainer, Tooltip as RechartsTooltip, Legend } from "recharts";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/@/components/ui/dialog"
import { Skeleton } from "src/@/components/ui/skeleton"
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "src/@/components/ui/tooltip"

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "src/@/components/ui/card"

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "src/@/components/ui/table"

import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "src/@/components/ui/chart"

import { HeaderPageComponentConfig } from "src/components/_dashboard/configuracoes";
import MenuDatas2 from "src/components/MenuDatas2";
import { getSpent } from "src/helpers/cliente.helper";
import { validaLabelMenuDatas } from "src/utils/functions";
import { Switch } from "src/@/components/ui/switch"
import { Icon } from '@iconify/react';
import v2_actionEditarCliente from "src/actions/v2/cliente/v2_actionEditarCliente";
import v2_getSpentChatsDetails_action from "src/actions/v2/cliente/v2.getSpentChatsDetails";

import { CONSUMO_COMPONENT_DESIGN } from './ConsumoComponent.design';

export function ConsumoComponent({ cliente }) {
  const [spent, setSpent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenuDatas, setOpenMenuDatas] = useState(false);
  const [inicio, setInicio] = useState(new Date());
  const [final, setFinal] = useState(new Date());
  const [periodo, setPeriodo] = useState("mes_atual");
  const [openModal, setOpenModal] = useState(false);
  const [useAdditionalCredits, setUseAdditionalCredits] = useState(false);
  const [openChatsDetailsModal, setOpenChatsDetailsModal] = useState(false);
  const [chatsDetails, setChatsDetails] = useState([]);
  const [loadingChatsDetails, setLoadingChatsDetails] = useState(false);
  const [filteredChatsDetails, setFilteredChatsDetails] = useState([]);
  const [filters, setFilters] = useState({
    templateName: '',
    priceCategory: '',
    number: '',
    userName: '',
    status: ''
  });


  async function handleGetSpent(startDate, endDate, periodo) {
    try {
      setLoading(true);
      startDate = startDate.toISOString().split('T')[0]
      endDate = endDate.toISOString().split('T')[0]
      let querys = `?inicio=${startDate}&final=${endDate}&periodo=${periodo}`
      const response = await getSpent(cliente._id, querys)
      setSpent(response?.data)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }


  // Dados de exemplo para o gráfico
  const dailyData = [
    { date: '2024-01-01', usage: 150 },
    { date: '2024-01-02', usage: 220 },
    { date: '2024-01-03', usage: 180 },
    { date: '2024-01-04', usage: 300 },
    { date: '2024-01-05', usage: 250 },
    { date: '2024-01-06', usage: 190 },
    { date: '2024-01-07', usage: 280 },
    { date: '2024-01-08', usage: 210 },
    { date: '2024-01-09', usage: 170 },
    { date: '2024-01-10', usage: 290 },
    { date: '2024-01-11', usage: 240 },
    { date: '2024-01-12', usage: 180 },
    { date: '2024-01-13', usage: 270 },
    { date: '2024-01-14', usage: 200 },
    { date: '2024-01-15', usage: 160 },
    { date: '2024-01-16', usage: 280 },
    { date: '2024-01-17', usage: 230 },
    { date: '2024-01-18', usage: 170 },
    { date: '2024-01-19', usage: 260 },
    { date: '2024-01-20', usage: 190 },
    { date: '2024-01-21', usage: 150 },
    { date: '2024-01-22', usage: 270 },
    { date: '2024-01-23', usage: 220 },
    { date: '2024-01-24', usage: 160 },
    { date: '2024-01-25', usage: 250 },
    { date: '2024-01-26', usage: 180 },
    { date: '2024-01-27', usage: 140 },
    { date: '2024-01-28', usage: 260 },
    { date: '2024-01-29', usage: 210 },
    { date: '2024-01-30', usage: 150 }
  ];

  async function handleChangeUseCreditsAdd(value) {
    try {
      let data = {
        scope: {
          "billing.allowCreditsAdd": value
        }
      }
      await v2_actionEditarCliente(cliente._id, data)
    } catch (error) {
      console.log(error)
    }
  }

  async function handleGetChatsDetails() {
    try {
      setLoadingChatsDetails(true);
      const startDate = inicio.toISOString().split('T')[0];
      const endDate = final.toISOString().split('T')[0];
      const querys = `?inicio=${startDate}&final=${endDate}&periodo=${periodo}`;
      const response = await v2_getSpentChatsDetails_action(cliente._id, querys);
      if (response?.data?.error === false && response?.data?.data) {
        setChatsDetails(response.data.data);
        setFilteredChatsDetails(response.data.data);
        setOpenChatsDetailsModal(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingChatsDetails(false);
    }
  }

  // Valores únicos para os selects
  const uniqueTemplates = useMemo(() => {
    const templates = chatsDetails
      .map(item => item.templateName)
      .filter((value, index, self) => value && self.indexOf(value) === index)
      .sort();
    return templates;
  }, [chatsDetails]);

  const uniquePriceCategories = useMemo(() => {
    const categories = chatsDetails
      .map(item => item.price_category)
      .filter((value, index, self) => value && self.indexOf(value) === index)
      .sort();
    return categories;
  }, [chatsDetails]);

  const uniqueUserNames = useMemo(() => {
    const userNames = chatsDetails
      .map(item => item.userName)
      .filter((value, index, self) => value && self.indexOf(value) === index)
      .sort();
    return userNames;
  }, [chatsDetails]);

  const uniqueStatuses = useMemo(() => {
    const statuses = chatsDetails
      .map(item => item.ackLabel)
      .filter((value, index, self) => value && self.indexOf(value) === index)
      .sort();
    return statuses;
  }, [chatsDetails]);

  // Soma por categoria de preço (SEMPRE usa todos os dados, sem filtros aplicados)
  const summaryByCategory = useMemo(() => {
    const summary = {};
    // Usa chatsDetails (dados completos) e não filteredChatsDetails (dados filtrados)
    chatsDetails.forEach(item => {
      const category = item.price_category || 'Sem categoria';
      summary[category] = (summary[category] || 0) + 1;
    });
    return Object.entries(summary)
      .map(([category, count]) => ({ category, count }))
      .sort((a, b) => b.count - a.count);
  }, [chatsDetails]); // Depende apenas de chatsDetails, não de filteredChatsDetails

  // Soma por nome do template (SEMPRE usa todos os dados, sem filtros aplicados) - Top 5
  const summaryByTemplate = useMemo(() => {
    const summary = {};
    // Usa chatsDetails (dados completos) e não filteredChatsDetails (dados filtrados)
    chatsDetails.forEach(item => {
      const template = item.templateName || 'Sem nome';
      summary[template] = (summary[template] || 0) + 1;
    });
    return Object.entries(summary)
      .map(([template, count]) => ({ template, count }))
      .sort((a, b) => b.count - a.count)
      .slice(0, 5); // Top 5
  }, [chatsDetails]); // Depende apenas de chatsDetails, não de filteredChatsDetails

  // Template mais usado
  const mostUsedTemplate = useMemo(() => {
    return summaryByTemplate.length > 0 ? summaryByTemplate[0] : null;
  }, [summaryByTemplate]);

  // Soma por nome do usuário (SEMPRE usa todos os dados, sem filtros aplicados) - Top 5
  const summaryByUser = useMemo(() => {
    const summary = {};
    // Usa chatsDetails (dados completos) e não filteredChatsDetails (dados filtrados)
    chatsDetails.forEach(item => {
      const userName = item.userName || 'Sem nome';
      summary[userName] = (summary[userName] || 0) + 1;
    });
    return Object.entries(summary)
      .map(([userName, count]) => ({ userName, count }))
      .sort((a, b) => b.count - a.count)
      .slice(0, 5); // Top 5
  }, [chatsDetails]); // Depende apenas de chatsDetails, não de filteredChatsDetails

  // Usuário que mais enviou
  const mostActiveUser = useMemo(() => {
    return summaryByUser.length > 0 ? summaryByUser[0] : null;
  }, [summaryByUser]);

  // Soma por status de entrega (ack)
  const summaryByStatus = useMemo(() => {
    const summary = { 'Enviado': 0, 'Entregue': 0, 'Lido': 0, 'Erro': 0, 'Pendente': 0 };
    chatsDetails.forEach(item => {
      const status = item.ackLabel || 'Pendente';
      summary[status] = (summary[status] || 0) + 1;
    });
    return Object.entries(summary)
      .filter(([_, count]) => count > 0)
      .map(([status, count]) => ({ status, count }));
  }, [chatsDetails]);

  // Cores para status de entrega
  const statusColors = {
    'Enviado': '#f59e0b', // amber
    'Entregue': '#3b82f6', // blue
    'Lido': '#10b981', // green
    'Erro': '#ef4444', // red
    'Pendente': '#6b7280' // gray
  };

  // Dados para gráfico de pizza - Status de Entrega
  const chartDataStatus = useMemo(() => {
    return summaryByStatus.map((item) => ({
      name: item.status,
      value: item.count,
      fill: statusColors[item.status] || '#8b5cf6'
    }));
  }, [summaryByStatus]);

  // Taxas de entrega
  const deliveryRates = useMemo(() => {
    const total = chatsDetails.length;
    if (total === 0) return { sent: 0, delivered: 0, read: 0, error: 0 };

    const sent = chatsDetails.filter(item => item.ack >= 1).length;
    const delivered = chatsDetails.filter(item => item.ack >= 2).length;
    const read = chatsDetails.filter(item => item.ack === 3).length;
    const error = chatsDetails.filter(item => item.ack === -1).length;

    return {
      sent: ((sent / total) * 100).toFixed(1),
      delivered: ((delivered / total) * 100).toFixed(1),
      read: ((read / total) * 100).toFixed(1),
      error: ((error / total) * 100).toFixed(1)
    };
  }, [chatsDetails]);

  // Paleta de cores variando entre violeta e rosa
  const colorPalette = [
    '#8b5cf6', // violet-600
    '#ec4899', // pink-500
    '#a78bfa', // violet-400
    '#f472b6', // pink-400
    '#c4b5fd', // violet-300
    '#f9a8d4', // pink-300
    '#ddd6fe', // violet-200
    '#fbcfe8', // pink-200
    '#ede9fe', // violet-100
    '#fce7f3'  // pink-100
  ];

  // Dados para gráfico de pizza - Categorias
  const chartDataCategories = useMemo(() => {
    return summaryByCategory.map((item, index) => ({
      name: item.category,
      value: item.count,
      fill: colorPalette[index % colorPalette.length]
    }));
  }, [summaryByCategory]);

  // Dados para gráfico de barras - Templates Top 5
  const chartDataTemplates = useMemo(() => {
    return summaryByTemplate.map((item, index) => ({
      name: item.template.length > 20 ? item.template.substring(0, 20) + '...' : item.template,
      fullName: item.template,
      value: item.count,
      fill: colorPalette[index % colorPalette.length]
    }));
  }, [summaryByTemplate]);

  // Dados para gráfico de barras - Usuários Top 5
  const chartDataUsers = useMemo(() => {
    return summaryByUser.map((item, index) => ({
      name: item.userName.length > 20 ? item.userName.substring(0, 20) + '...' : item.userName,
      fullName: item.userName,
      value: item.count,
      fill: colorPalette[index % colorPalette.length]
    }));
  }, [summaryByUser]);

  // Estatísticas resumidas
  const stats = useMemo(() => {
    const total = chatsDetails.length;
    const uniqueTemplates = new Set(chatsDetails.map(item => item.templateName)).size;
    const uniqueUsers = new Set(chatsDetails.map(item => item.userName)).size;
    const uniqueCategories = new Set(chatsDetails.map(item => item.price_category)).size;

    return {
      total,
      uniqueTemplates,
      uniqueUsers,
      uniqueCategories
    };
  }, [chatsDetails]);

  function handleFilterChange(filterName, value) {
    const newFilters = { ...filters, [filterName]: value };
    setFilters(newFilters);

    // Aplicar filtros
    let filtered = [...chatsDetails];

    if (newFilters.templateName && newFilters.templateName !== 'all') {
      filtered = filtered.filter(item =>
        item.templateName === newFilters.templateName
      );
    }

    if (newFilters.priceCategory && newFilters.priceCategory !== 'all') {
      filtered = filtered.filter(item =>
        item.price_category === newFilters.priceCategory
      );
    }

    if (newFilters.number) {
      filtered = filtered.filter(item =>
        item.number?.includes(newFilters.number)
      );
    }

    if (newFilters.userName && newFilters.userName !== 'all') {
      filtered = filtered.filter(item =>
        item.userName === newFilters.userName
      );
    }

    if (newFilters.status && newFilters.status !== 'all') {
      filtered = filtered.filter(item =>
        item.ackLabel === newFilters.status
      );
    }

    setFilteredChatsDetails(filtered);
  }

  function handleClearFilters() {
    setFilters({
      templateName: '',
      priceCategory: '',
      number: '',
      userName: '',
      status: ''
    });
    setFilteredChatsDetails(chatsDetails);
  }

  return (
    <div className={CONSUMO_COMPONENT_DESIGN.page.container}>
      <div className={CONSUMO_COMPONENT_DESIGN.page.header.container}>
        <div>
          <h1 className={CONSUMO_COMPONENT_DESIGN.page.header.title}>Consumo</h1>
          <p className={CONSUMO_COMPONENT_DESIGN.page.header.subtitle}>Acompanhe o uso de créditos e recursos da sua conta.</p>
        </div>
        <div>
          <MenuDatas2
            anchorEl={anchorEl}
            open={openMenuDatas}
            onClose={() => setAnchorEl(false)}
            inicial={inicio}
            final={final}
            content={validaLabelMenuDatas(periodo, inicio, final)}
            changeInicial={(newValue) => setInicio(newValue)}
            changeFinal={(newValue) => setFinal(newValue)}
            onSelect={(value) => {
              setPeriodo(value);
              setAnchorEl(null);
            }}
            onPesquisar={(startArg, endArg, periodoArg) => {
              const s = startArg ?? inicio;
              const e = endArg ?? final;
              const p = periodoArg !== undefined ? periodoArg : 'null';
              setAnchorEl(null);
              setPeriodo(p);
              handleGetSpent(s, e, p);
            }}
          />
        </div>
      </div>
      <div className="space-y-8">
        {/* Resumo Total */}
        <Card className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div className="flex items-center gap-4">
              <div>
                <h3 className="text-base font-semibold text-gray-900">Resumo Total</h3>
                <p className="text-xs text-gray-500">Período: {validaLabelMenuDatas(periodo, inicio, final)}</p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row gap-6">
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <div className="text-center md:text-right cursor-help">
                      <div className="flex items-center justify-center md:justify-end gap-1">
                        <p className="text-xs text-gray-600">Créditos Utilizados</p>
                        <Icon icon="material-symbols:info-outline" width={14} height={14} className="text-gray-400" />
                      </div>
                      {loading ? (
                        <Skeleton className="h-7 w-24 bg-violet-100" />
                      ) : (
                        <p className="text-lg font-bold text-violet-600">
                          {spent?.credits?.total?.use}{periodo === 'mes_atual' && `/${spent?.credits?.total?.limit}`}
                        </p>
                      )}
                    </div>
                  </TooltipTrigger>
                  <TooltipContent side="top" className="max-w-xs">
                    <div className="space-y-2">
                      <p className="font-medium">Créditos Utilizados vs Contratados</p>
                      <div className="text-sm space-y-1">
                        <p><strong>Utilizados:</strong> {spent?.credits?.total?.use || 0} créditos</p>
                        {periodo === 'mes_atual' && (
                          <p><strong>Contratados:</strong> {spent?.credits?.total?.limit || 0} créditos</p>
                        )}
                        <p className="text-xs text-gray-500 mt-2">
                          Os créditos são consumidos conforme o uso das funcionalidades de IA da plataforma.
                        </p>
                      </div>
                    </div>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>


              {periodo === 'mes_atual' && (
                <div className="flex flex-row md:flex-row gap-6">
                  {spent?.credits?.total?.credits_add > 0 && (
                    <div className="text-center md:text-right">
                      <p className="text-xs text-gray-600">Creditos Adicionais</p>
                      {loading ? (
                        <Skeleton className="h-7 w-24 bg-violet-100" />
                      ) : (
                        <p className={`text-lg font-bold ${((spent?.credits?.total?.limit - spent?.credits?.total?.use) * 0.33) < 0 ? 'text-red-500' : 'text-green-600'}`}>
                          {spent?.credits?.total?.credits_add}
                        </p>
                      )}
                    </div>
                  )}
                  {/* 
                          <div className="text-center md:text-right">
                            <p className="text-xs text-gray-600">Saldo em R$</p>
                            {loading ? (
                              <Skeleton className="h-7 w-24 bg-violet-100" />
                            ) : (
                              <p className={`text-lg font-bold ${((spent?.credits?.total?.limit - spent?.credits?.total?.use) * 0.33) < 0 ? 'text-red-500' : 'text-green-600'}`}>
                                R$ {((spent?.credits?.total?.limit - spent?.credits?.total?.use) * 0.33).toFixed(2)}
                              </p>
                            )}
                          </div> */}
                </div>
              )}
            </div>
          </div>
          {/* <div className="mt-4 pt-4 border-t border-gray-100">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-2">
                        <Switch
                          id="additional-credits"
                          checked={useAdditionalCredits}
                          onCheckedChange={(value) => {
                            setUseAdditionalCredits(value);
                            handleChangeUseCreditsAdd(value);
                          }}
                        />
                        <label
                          htmlFor="additional-credits"
                          className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                        >
                          Habilitar uso de créditos adicionais
                        </label>
                      </div>
                      <p className="text-xs text-gray-500">
                        Valor: R$ 0,66/crédito
                      </p>
                    </div>
                    {useAdditionalCredits && (
                      <div className="mt-2 flex items-center gap-2 text-xs text-amber-600 bg-amber-50 p-2 rounded">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                          <line x1="12" y1="9" x2="12" y2="13" />
                          <line x1="12" y1="17" x2="12.01" y2="17" />
                        </svg>
                        <span>Os créditos adicionais utilizados serão cobrados na próxima fatura</span>
                      </div>
                    )}
                  </div> */}
        </Card>

        {/* Consumo por Ferramenta */}
        <div>
          <h3 className="text-base font-semibold text-gray-900 mb-3">Consumo por Ferramenta</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
            <Card className="bg-white p-4 rounded-xl shadow-sm border border-gray-200 cursor-pointer hover:shadow-md hover:border-violet-300 transition-all group" onClick={handleGetChatsDetails}>
              <div className="flex flex-col gap-2">
                <div className="flex items-center justify-between">
                  <h3 className="text-sm font-semibold text-violet-600">Conversas</h3>
                  <Icon icon="material-symbols:info-outline" width={16} height={16} className="text-gray-400" />
                </div>
                <div className="flex items-center justify-between">
                  <p className="text-xs text-gray-600">Créditos:</p>
                  <p className="text-sm font-bold">{spent?.credits?.uso?.chats || 0}</p>
                </div>
                <Button
                  variant="ghost"
                  size="sm"
                  className="text-xs h-6 mt-1"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleGetChatsDetails();
                  }}
                  disabled={loadingChatsDetails}
                >
                  {loadingChatsDetails ? "Carregando..." : "Ver detalhes"}
                </Button>
              </div>
            </Card>
            <Card className="bg-white p-4 rounded-xl shadow-sm border border-gray-200">
              <div className="flex flex-col gap-2">
                <h3 className="text-sm font-semibold text-violet-600">Copilot</h3>
                <div className="flex items-center justify-between">
                  <p className="text-xs text-gray-600">Créditos:</p>
                  <p className="text-sm font-bold">{spent?.credits?.uso?.copilot || 0}</p>
                </div>
              </div>
            </Card>

            <Card className="bg-white p-4 rounded-xl shadow-sm border border-gray-200">
              <div className="flex flex-col gap-2">
                <h3 className="text-sm font-semibold text-violet-600">Agentes</h3>
                <div className="flex items-center justify-between">
                  <p className="text-xs text-gray-600">Créditos:</p>
                  <p className="text-sm font-bold">{spent?.credits?.uso?.agents || 0}</p>
                </div>
              </div>
            </Card>

            <Card className="bg-white p-4 rounded-xl shadow-sm border border-gray-200">
              <div className="flex flex-col gap-2">
                <h3 className="text-sm font-semibold text-violet-600">Automações</h3>
                <div className="flex items-center justify-between">
                  <p className="text-xs text-gray-600">Créditos:</p>
                  <p className="text-sm font-bold">{spent?.credits?.uso?.automations || 0}</p>
                </div>
              </div>
            </Card>

            <Card className="bg-white p-4 rounded-xl shadow-sm border border-gray-200">
              <div className="flex flex-col gap-2">
                <h3 className="text-sm font-semibold text-violet-600">Voz</h3>
                <div className="flex items-center justify-between">
                  <p className="text-xs text-gray-600">Créditos:</p>
                  <p className="text-sm font-bold">{spent?.credits?.uso?.voice || 0}</p>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
      {/* <Card className="mt-8 bg-gradient-to-l from-slate-50 to-white">
                  <CardHeader>
                    <CardTitle>Consumo Diário</CardTitle>
                    <CardDescription>Créditos utilizados nos ultimos 30 dias</CardDescription>
                  </CardHeader>
                  <CardContent>
                    <ChartContainer className="h-72 w-full" config={chartConfig}>
                      <BarChart accessibilityLayer data={dailyData}>
                        <CartesianGrid vertical={false} />
                        <XAxis
                          dataKey="date"
                          tickLine={false}
                          tickMargin={10}
                          axisLine={false}
                          tickFormatter={(value) => value.slice(8, 10) + "/" + value.slice(5, 7)}
                        />
                        <ChartTooltip content={<ChartTooltipContent hideLabel />} />
                        <Bar
                          dataKey="usage"
                          fill="var(--color-consumo)"
                          radius={[4, 4, 0, 0]}
                        />
                      </BarChart>
                    </ChartContainer>
                  </CardContent>
                </Card> */}



      < Dialog open={openChatsDetailsModal} onOpenChange={(open) => {
        setOpenChatsDetailsModal(open);
        if (!open) {
          handleClearFilters();
        }
      }
      }>
        <DialogContent className="sm:max-w-[95vw] sm:min-w-[90vw] max-w-[95vw] max-h-[90vh] overflow-hidden flex flex-col p-0 rounded-xl">
          <div className="p-6 pb-2 border-b border-gray-100">
            <DialogHeader>
              <DialogTitle className="text-xl font-bold text-gray-900">Detalhes de Consumo em Conversas</DialogTitle>
              <DialogDescription className="text-sm text-gray-500 mt-1">
                Período: {validaLabelMenuDatas(periodo, inicio, final)}
              </DialogDescription>
            </DialogHeader>
          </div>
          <div className="flex-1 flex gap-4 overflow-hidden p-6 pt-4 bg-gray-50/50">
            {/* Coluna Esquerda - Resumos e Gráficos */}
            <div className="w-1/2 flex flex-col overflow-hidden">
              <div 
                className="flex-1 overflow-y-auto pr-2 space-y-3"
                style={{ scrollbarWidth: 'thin', scrollbarColor: '#8b5cf6 #f3f4f6' }}
              >
              {/* Estatísticas Resumidas */}
              <div className="grid grid-cols-3 gap-2">
                <Card className="bg-gradient-to-br from-violet-500 to-violet-600 text-white border-0">
                  <CardContent className="p-3">
                    <div className="text-xs opacity-90 mb-1">Total de Mensagens</div>
                    <div className="text-2xl font-bold">{stats.total}</div>
                  </CardContent>
                </Card>
                <Card className="bg-white border border-gray-200">
                  <CardContent className="p-3">
                    <div className="text-xs text-gray-600 mb-1">Templates Únicos</div>
                    <div className="text-xl font-bold text-violet-600">{stats.uniqueTemplates}</div>
                  </CardContent>
                </Card>
                <Card className="bg-white border border-gray-200">
                  <CardContent className="p-3">
                    <div className="text-xs text-gray-600 mb-1">Usuários Únicos</div>
                    <div className="text-xl font-bold text-violet-600">{stats.uniqueUsers}</div>
                  </CardContent>
                </Card>
              </div>

              {/* Gráfico de Pizza - Categorias */}
              {chartDataCategories.length > 0 && (
                <Card className="border border-gray-200">
                  <CardHeader className="pb-2">
                    <CardTitle className="text-sm font-semibold">Por Categoria</CardTitle>
                  </CardHeader>
                  <CardContent className="p-2">
                    <div className="h-48">
                      <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                          <defs>
                            {chartDataCategories.map((entry, index) => (
                              <linearGradient key={`grad-cat-${index}`} id={`grad-cat-${index}`} x1="0" y1="0" x2="1" y2="1">
                                <stop offset="0%" stopColor={entry.fill} stopOpacity={1}/>
                                <stop offset="100%" stopColor={entry.fill} stopOpacity={0.6}/>
                              </linearGradient>
                            ))}
                          </defs>
                          <Pie
                            data={chartDataCategories}
                            cx="50%"
                            cy="50%"
                            labelLine={false}
                            label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                            outerRadius={70}
                            fill="#8884d8"
                            dataKey="value"
                            stroke="none"
                          >
                            {chartDataCategories.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={`url(#grad-cat-${index})`} />
                            ))}
                          </Pie>
                          <RechartsTooltip />
                        </PieChart>
                      </ResponsiveContainer>
                    </div>
                  </CardContent>
                </Card>
              )}

              {/* Gráfico de Barras - Templates Top 5 */}
              {chartDataTemplates.length > 0 && (
                <Card className="border border-gray-200">
                  <CardHeader className="pb-2">
                    <CardTitle className="text-sm font-semibold">Top 5 Templates</CardTitle>
                  </CardHeader>
                  <CardContent className="p-2">
                    <div className="h-48">
                      <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={chartDataTemplates} layout="vertical">
                          <defs>
                            <linearGradient id="barGradientTemplates" x1="0" y1="0" x2="1" y2="0">
                              <stop offset="0%" stopColor="#8b5cf6" stopOpacity={1}/>
                              <stop offset="100%" stopColor="#ec4899" stopOpacity={0.9}/>
                            </linearGradient>
                          </defs>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis type="number" />
                          <YAxis dataKey="name" type="category" width={100} tick={{ fontSize: 10 }} />
                          <RechartsTooltip />
                          <Bar dataKey="value" fill="url(#barGradientTemplates)" radius={[0, 4, 4, 0]} />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  </CardContent>
                </Card>
              )}

              {/* Gráfico de Barras - Usuários Top 5 */}
              {chartDataUsers.length > 0 && (
                <Card className="border border-gray-200">
                  <CardHeader className="pb-2">
                    <CardTitle className="text-sm font-semibold">Top 5 Usuários</CardTitle>
                  </CardHeader>
                  <CardContent className="p-2">
                    <div className="h-48">
                      <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={chartDataUsers} layout="vertical">
                          <defs>
                            <linearGradient id="barGradientUsers" x1="0" y1="0" x2="1" y2="0">
                              <stop offset="0%" stopColor="#8b5cf6" stopOpacity={1}/>
                              <stop offset="100%" stopColor="#ec4899" stopOpacity={0.9}/>
                            </linearGradient>
                          </defs>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis type="number" />
                          <YAxis dataKey="name" type="category" width={100} tick={{ fontSize: 10 }} />
                          <RechartsTooltip />
                          <Bar dataKey="value" fill="url(#barGradientUsers)" radius={[0, 4, 4, 0]} />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  </CardContent>
                </Card>
              )}

              {/* Gráfico de Status de Entrega */}
              {chartDataStatus.length > 0 && (
                <Card className="border border-gray-200">
                  <CardHeader className="pb-2">
                    <CardTitle className="text-sm font-semibold">Taxa de Entrega</CardTitle>
                  </CardHeader>
                  <CardContent className="p-3">
                    <div className="flex gap-4">
                      {/* Gráfico à esquerda */}
                      <div className="w-1/2 h-44">
                        <ResponsiveContainer width="100%" height="100%">
                          <PieChart>
                            <defs>
                              {chartDataStatus.map((entry, index) => (
                                <linearGradient key={`grad-status-${index}`} id={`grad-status-${index}`} x1="0" y1="0" x2="1" y2="1">
                                  <stop offset="0%" stopColor={entry.fill} stopOpacity={1}/>
                                  <stop offset="100%" stopColor={entry.fill} stopOpacity={0.6}/>
                                </linearGradient>
                              ))}
                            </defs>
                            <Pie
                              data={chartDataStatus}
                              cx="50%"
                              cy="50%"
                              labelLine={false}
                              outerRadius={65}
                              fill="#8884d8"
                              dataKey="value"
                              stroke="none"
                            >
                              {chartDataStatus.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={`url(#grad-status-${index})`} />
                              ))}
                            </Pie>
                            <RechartsTooltip />
                            <Legend
                              layout="vertical"
                              align="right"
                              verticalAlign="middle"
                              iconSize={8}
                              wrapperStyle={{ fontSize: '10px' }}
                            />
                          </PieChart>
                        </ResponsiveContainer>
                      </div>
                      {/* Resumos à direita */}
                      <div className="w-1/2 grid grid-cols-2 gap-2 content-center">
                        <div className="text-center p-3 bg-amber-50 rounded-lg border border-amber-100">
                          <div className="text-xl font-bold text-amber-600">{deliveryRates.sent}%</div>
                          <div className="text-[11px] text-amber-700 font-medium">Enviado</div>
                        </div>
                        <div className="text-center p-3 bg-blue-50 rounded-lg border border-blue-100">
                          <div className="text-xl font-bold text-blue-600">{deliveryRates.delivered}%</div>
                          <div className="text-[11px] text-blue-700 font-medium">Entregue</div>
                        </div>
                        <div className="text-center p-3 bg-green-50 rounded-lg border border-green-100">
                          <div className="text-xl font-bold text-green-600">{deliveryRates.read}%</div>
                          <div className="text-[11px] text-green-700 font-medium">Lido</div>
                        </div>
                        <div className="text-center p-3 bg-red-50 rounded-lg border border-red-100">
                          <div className="text-xl font-bold text-red-600">{deliveryRates.error}%</div>
                          <div className="text-[11px] text-red-700 font-medium">Erro</div>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              )}
              </div>
            </div>

            {/* Coluna Direita - Tabela */}
            <div className="w-1/2 flex flex-col overflow-hidden">
              <div
                className="flex-1 overflow-x-auto overflow-y-auto"
                style={{ scrollbarWidth: 'thin', scrollbarColor: '#8b5cf6 #f3f4f6' }}
              >
                <style jsx>{`
              div::-webkit-scrollbar {
                width: 8px;
                height: 8px;
              }
              div::-webkit-scrollbar-track {
                background: #f3f4f6;
                border-radius: 4px;
              }
              div::-webkit-scrollbar-thumb {
                background: #7c3aed;
                border-radius: 4px;
              }
              div::-webkit-scrollbar-thumb:hover {
                background: #7c3aed;
              }
            `}</style>
                {filteredChatsDetails.length === 0 ? (
                  <div className="flex items-center justify-center py-12">
                    <p className="text-sm text-gray-500">
                      {chatsDetails.length === 0
                        ? 'Nenhum detalhe encontrado para o período selecionado.'
                        : 'Nenhum resultado encontrado com os filtros aplicados.'}
                    </p>
                  </div>
                ) : (
                  <div className="rounded-lg border border-gray-200 overflow-hidden min-w-full">
                    <Table className="min-w-[900px]">
                      <TableHeader>
                        <TableRow className="bg-gradient-to-r from-violet-50 to-violet-100/50 hover:bg-gradient-to-r hover:from-violet-50 hover:to-violet-100/50">
                          <TableHead className="font-semibold text-violet-700 whitespace-nowrap">Nome do Template</TableHead>
                          <TableHead className="font-semibold text-violet-700 whitespace-nowrap">Categoria de Preço</TableHead>
                          <TableHead className="font-semibold text-violet-700 whitespace-nowrap">Número</TableHead>
                          <TableHead className="font-semibold text-violet-700 whitespace-nowrap">Nome do Usuário</TableHead>
                          <TableHead className="font-semibold text-violet-700 whitespace-nowrap">Status</TableHead>
                          <TableHead className="font-semibold text-violet-700 whitespace-nowrap">Data do Envio</TableHead>
                        </TableRow>
                        <TableRow className="bg-gray-50 hover:bg-gray-50">
                          <TableHead className="p-2">
                            <Select
                              value={filters.templateName || 'all'}
                              onValueChange={(value) => handleFilterChange('templateName', value)}
                            >
                              <SelectTrigger className="bg-white h-9 w-full">
                                <SelectValue placeholder="Todos" />
                              </SelectTrigger>
                              <SelectContent>
                                <SelectItem value="all">Todos</SelectItem>
                                {uniqueTemplates.map((template) => (
                                  <SelectItem key={template} value={template}>
                                    {template}
                                  </SelectItem>
                                ))}
                              </SelectContent>
                            </Select>
                          </TableHead>
                          <TableHead className="p-2">
                            <Select
                              value={filters.priceCategory || 'all'}
                              onValueChange={(value) => handleFilterChange('priceCategory', value)}
                            >
                              <SelectTrigger className="bg-white h-9 w-full">
                                <SelectValue placeholder="Todos" />
                              </SelectTrigger>
                              <SelectContent>
                                <SelectItem value="all">Todos</SelectItem>
                                {uniquePriceCategories.map((category) => (
                                  <SelectItem key={category} value={category}>
                                    {category}
                                  </SelectItem>
                                ))}
                              </SelectContent>
                            </Select>
                          </TableHead>
                          <TableHead className="p-2">
                            <Input
                              value={filters.number}
                              onChange={(e) => handleFilterChange('number', e.target.value)}
                              placeholder="Buscar..."
                              className="bg-white w-full h-9"
                            />
                          </TableHead>
                          <TableHead className="p-2">
                            <Select
                              value={filters.userName || 'all'}
                              onValueChange={(value) => handleFilterChange('userName', value)}
                            >
                              <SelectTrigger className="bg-white h-9 w-full">
                                <SelectValue placeholder="Todos" />
                              </SelectTrigger>
                              <SelectContent>
                                <SelectItem value="all">Todos</SelectItem>
                                {uniqueUserNames.map((userName) => (
                                  <SelectItem key={userName} value={userName}>
                                    {userName}
                                  </SelectItem>
                                ))}
                              </SelectContent>
                            </Select>
                          </TableHead>
                          <TableHead className="p-2">
                            <Select
                              value={filters.status || 'all'}
                              onValueChange={(value) => handleFilterChange('status', value)}
                            >
                              <SelectTrigger className="bg-white h-9 w-full">
                                <SelectValue placeholder="Todos" />
                              </SelectTrigger>
                              <SelectContent>
                                <SelectItem value="all">Todos</SelectItem>
                                {uniqueStatuses.map((status) => (
                                  <SelectItem key={status} value={status}>
                                    {status}
                                  </SelectItem>
                                ))}
                              </SelectContent>
                            </Select>
                          </TableHead>
                          <TableHead className="p-2">
                            <div className="flex items-center justify-between gap-2">
                              {filteredChatsDetails.length !== chatsDetails.length && (
                                <span className="text-xs text-gray-600">
                                  {filteredChatsDetails.length} de {chatsDetails.length}
                                </span>
                              )}
                              <Button
                                variant="ghost"
                                size="sm"
                                onClick={handleClearFilters}
                                className="text-xs h-7 px-2"
                                disabled={!filters.templateName && !filters.priceCategory && !filters.number && !filters.userName && !filters.status}
                              >
                                Limpar
                              </Button>
                            </div>
                          </TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {filteredChatsDetails.map((item, index) => (
                          <TableRow
                            key={item._id || index}
                            className={`transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'} hover:bg-violet-50/50`}
                          >
                            <TableCell className="font-medium text-gray-900 whitespace-nowrap">
                              {item.templateName || <span className="text-gray-400 italic">Sem nome</span>}
                            </TableCell>
                            <TableCell className="text-gray-600 whitespace-nowrap">
                              {item.price_category || <span className="text-gray-400 italic text-sm">-</span>}
                            </TableCell>
                            <TableCell className="text-gray-600 whitespace-nowrap">
                              {item.number || <span className="text-gray-400 italic text-sm">-</span>}
                            </TableCell>
                            <TableCell className="text-gray-600 whitespace-nowrap">
                              {item.userName || <span className="text-gray-400 italic text-sm">-</span>}
                            </TableCell>
                            <TableCell className="whitespace-nowrap">
                              {item.ackLabel ? (
                                <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${
                                  item.ack === 3 ? 'bg-green-100 text-green-700' :
                                  item.ack === 2 ? 'bg-blue-100 text-blue-700' :
                                  item.ack === 1 ? 'bg-amber-100 text-amber-700' :
                                  item.ack === -1 ? 'bg-red-100 text-red-700' :
                                  'bg-gray-100 text-gray-700'
                                }`}>
                                  {item.ackLabel}
                                </span>
                              ) : (
                                <span className="text-gray-400 italic text-sm">-</span>
                              )}
                            </TableCell>
                            <TableCell className="text-gray-600 whitespace-nowrap">
                              {item.date ? (
                                <div className="flex flex-col">
                                  <span className="text-sm font-medium">
                                    {new Date(item.date).toLocaleDateString('pt-BR', {
                                      day: '2-digit',
                                      month: '2-digit',
                                      year: 'numeric'
                                    })}
                                  </span>
                                  <span className="text-xs text-gray-500">
                                    {new Date(item.date).toLocaleTimeString('pt-BR', {
                                      hour: '2-digit',
                                      minute: '2-digit'
                                    })}
                                  </span>
                                </div>
                              ) : (
                                <span className="text-gray-400 italic text-sm">Data não disponível</span>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog >
    </div >
  )
}